// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"83bfe3f6","488":"f7640f6f"}[chunkId] + ".chunk.js";
};